<template>
    <div class="min-h-screen login__background lg:bg-white">
        <LangSwitch :alwaysOpenOnTop="true" class="mt-2 mb-8 absolute top-4 sm:right-6 text-white" arrowColor="#fff" />
        <div class="w-full absolute z-10 top-0 left-0 login__header"></div>

        <div class="flex flex-col items-center relative z-20 px-4 lg:px-0 login__body">
            <ApplicationLogoWhite :class="'mb-10'"/>

            <div class="login__content bg-white rounded px-6 lg:px-11 py-11">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
import ApplicationLogoWhite from '@/Components/ApplicationLogoWhite';
import LangSwitch from "@/Components/LangSwitch";

export default {
    components: {LangSwitch, ApplicationLogoWhite },
};
</script>
